<template>
    <div class="base-tree"
         :class="{'not-expand':!isExpand}">
        <div class="tree-search"
             v-if="isNeedSearch">
            <input type="text"
                   :placeholder="placeholder"
                   v-model="condition"
                   @keyup.enter="enterSearch"
                   @focus="searchFocus"/>
            <svg xmlns="http://www.w3.org/2000/svg"
                 v-if="!instantOrEnter"
                 xmlns:xlink="http://www.w3.org/1999/xlink"
                 t="1522303067229"
                 class="icon search-handle"
                 viewBox="0 0 1024 1024"
                 version="1.1"
                 @click="enterSearch">
                <defs>Wisdom UI</defs>
                <path d="M480.32426667 885.00906667c-238.11413333 0-431.99146667-193.3312-431.99146667-431.99146667s193.3312-431.99146667 431.99146667-431.99146667 431.99146667 193.3312 431.99146666 431.99146667-193.87733333 431.99146667-431.99146666 431.99146667z m0-715.9808c-156.19413333 0-283.4432 127.24906667-283.4432 283.4432s127.24906667 283.4432 283.4432 283.4432 283.4432-127.24906667 283.4432-283.4432c0.54613333-156.19413333-126.70293333-283.4432-283.4432-283.4432z"/>
                <path d="M667.10186667 820.0192c-34.4064-34.4064-34.4064-90.65813333 0-125.06453333 34.4064-34.4064 90.65813333-34.4064 125.06453333 0l157.2864 157.2864c34.4064 34.4064 34.4064 90.65813333 0 125.06453333-34.4064 34.4064-90.65813333 34.4064-125.06453333 0l-157.2864-157.2864z"/>
            </svg>
        </div>
        <div class="tree-content">
            <transition name="fade">
                <slot name="empty"
                      v-if="!baseData || baseData.length===0">
                    <div class="is-empty-data">
                        <p>相关内容为空</p>
                    </div>
                </slot>
                <div v-else
                     id="base-tree-root">
                    <base-tree-item v-for="(d,index) in baseData"
                                    :key="index+d[props.label]"
                                    :index="index"
                                    :data="d"
                                    :props="props"
                                    :is-default-expand="isDefaultExpand"
                                    :generate-id-rules="generateIdRules"/>
                </div>
            </transition>
        </div>
        <div class="expand-handle"
             :class="{'yes':isExpand,'no':!isExpand}"
             @click="handleExpand">
            <svg xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink"
                 t="1519973852380"
                 class="icon"
                 viewBox="0 0 1335 1024"
                 width="20.859375"
                 height="16">
                <defs>Wisdom UI</defs>
                <path d="M1113.76385791 845.70962627c0 20.52015593-16.48184616 37.07985319-36.91328729 37.07985321h-811.61797746c-20.40066352-0.08780882-36.87888796-16.67647394-36.83272044-37.07985321 0-20.51653494 16.47822517-37.07623221 36.91328729-37.0762322h811.53741061c20.34996977 0 36.91328729 16.47822517 36.91328729 37.0762322z m-332.06298029-333.70691053a37.07804271 37.07804271 0 0 1-37.07985318 37.07623221H265.47972591a37.07713746 37.07713746 0 1 1 0-74.15608541h479.05982642a36.82095224 36.82095224 0 0 1 26.29111003 10.78512147 36.84629913 36.84629913 0 0 1 10.78874317 26.29473172h0.08147209zM1113.76385791 178.29127897c0 20.51653494-16.48184616 37.07985319-36.91328729 37.07985321h-811.61797746C244.83192964 215.27879712 228.35370448 198.69103725 228.39987272 178.29127897 228.39987272 157.77474403 244.87809717 141.21142578 265.31316001 141.21142578h811.53741061c20.34996977 0 36.91328729 16.47822517 36.91328729 37.07985319z m-247.44042058 492.90015956l158.36947341-159.18872279-158.36947341-159.19324902c-13.93176293-14.56543627-13.74799736-37.57140297 0.41007769-51.91052712 14.19066389-14.33912416 37.28534465-14.56181528 51.7475822-0.49517006l184.48677628 185.395645c14.36718677 14.51202678 14.36718677 37.89005013 0 52.40569715L918.48109722 723.59713569c-14.43779664 14.08746517-37.53519315 13.90370033-51.74758219-0.41007696-14.21148453-14.35360808-14.3952501-37.419321-0.41007769-51.9956202z"
                      fill="#848E9A"/>
            </svg>
        </div>
        <transition name="fade">
            <div class="is-Loading"
                 v-show="isLoading">
                <div class="mounted-before"></div>
            </div>
        </transition>
    </div>
</template>
<script>
    import BaseTreeItem from "./composition/base-tree-item";
    // import {deepAssign} from "../../../src/utils/util";

    export default {
        name: "BaseTree",
        components: {
            BaseTreeItem
        },
        props: {
            inputInterval: {
                type: Number,
                default: 50
            },
            loading: Boolean,
            data: {
                type: Array,
                default: () => []
            },
            placeholder: {
                type: String,
                default: "请输入关键字搜索"
            },
            isDuplex: {
                type: Boolean,
                default: false
            },
            props: {
                type: Object,
                default: () => {
                    return {
                        children: "children",
                        label: "label",
                        tag: "tag"
                    };
                }
            },
            isNeedSearch: {
                type: Boolean,
                default: true
            },
            handleItem: {
                type: Function,
                default: tel => {
                }
            },
            defaultSelectData: Object,
            isSelectClickItem: {
                type: Function,
                default: tel => true
            },
            isExpandItem: {
                type: Function,
                default: tel => true
            },
            isDefaultExpand: {
                type: Function,
                default: (data, index, level) => false
            },
            generateIdRules: {
                type: Function,
                default: (data, label) => data[label]
            },
            search: {
                type: Function,
                default: (condition, data, defaultSearchFn) => {
                    let d = JSON.parse(JSON.stringify(data));
                    typeof defaultSearchFn === "function" && defaultSearchFn(d, condition);
                    return d;
                }
            },
            instantOrEnter: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                selectData: this.defaultSelectData,
                baseData: this.data,
                condition: "",
                isLoading: true,
                currentNode: null,
                isExpand: true
            };
        },
        methods: {
            handleExpand() {
                let event = document.createEvent('Event');
                event.initEvent('resize', true, true);
                window.dispatchEvent(event);
                this.isExpand = !this.isExpand;
            },
            searchFocus(e) {
                let el = e.srcElement || e.target;
                el && el.select();
            },
            spliceNullItem(array, i) {
                array.splice(i, 1);
                return this.filterArrayEmptyItem(array);
            },
            filterArrayEmptyItem(array) {
                if (array) for (let i = 0; i < array.length; i++) {
                    if (!array[i]) return this.spliceNullItem(array, i);
                }
            },
            filterItemData(data, itemData, index, condition) {
                let label = this.props.label,
                    children = this.props.children,
                    childrenData = itemData[children],
                    childrenFlag = false;
                childrenData && childrenData.forEach((d, index) => {
                    let filterFlag = this.filterData(d[children], condition);
                    if ((d[label] + '').indexOf(condition) > -1 ||
                        (d['searchField'] + '').indexOf(condition) > -1 ||
                        filterFlag) childrenFlag = true;
                    else delete childrenData[index];
                });
                this.filterArrayEmptyItem(childrenData);
                if (childrenFlag || (itemData[label] + '').indexOf(condition) > -1 || (itemData['searchField'] + '').indexOf(condition) > -1) return true;
                else delete data[index];
                return false;
            },
            filterHandle(data, condition) {
                let flag = false;
                for (let i = 0; i < data.length; i++)
                    if (this.filterItemData(data, data[i], i, condition)) flag = true;
                this.filterArrayEmptyItem(data);
                return flag;
            },
            filterData(data, condition) {
                let flag = false;
                this.isLoading = true;
                if (data && data.length > 0 && this.filterHandle(data, condition)) flag = true;
                return flag;
            },
            getParentNode(itemEl) {
                let parentNode = itemEl.parentNode.parentNode;
                return {
                    parentNode,
                    treeData: parentNode.treeData
                };
            },
            expandTheOuterLayer(item) {
                let treeItem = item && item.parentNode && item.parentNode.parentNode;
                if (treeItem.classList && treeItem.classList.contains("base-tree-item")) {
                    treeItem.classList.remove("is-hide");
                    this.expandTheOuterLayer(treeItem);
                }
            },
            defaultSelectItem() {
                let data = this.selectData || (this.data && this.data[0]), node;
                if (data) node = this.$el.querySelector(`[item-id="${this.generateIdRules(data, this.props.label)}"]`);
                if (this.currentNode) this.currentNode.classList.remove("is-current");
                if (node) {
                    node.classList.remove("is-hide");
                    this.treeInfo.defaultSelected = false;
                    if (this.isSelectClickItem(node, this.treeInfo)) node.classList.add("is-current");
                    this.treeInfo.defaultSelected = true;
                    this.expandTheOuterLayer(node);
                    this.currentNode = node;
                }
                if (this.isLoading) this.isLoading = false;
            },
            changeNodeStatus(data, isOnline) {
                let node = this.$el.querySelector(`[item-id="${this.generateIdRules(data, this.props.label)}"]`);
                if (node) {
                    isOnline ? node.classList.add("is-online") : node.classList.remove("is-online");
                    node.treeData.online = isOnline ? 1 : 0;
                    // deepAssign(this.data, this.baseData);
                    // this.changeODataStatus(data, isOnline);
                }
            },
            clickItem(tel) {
                if (this.isSelectClickItem(tel, this.treeInfo)) {
                    this.handleItem(tel);
                    this.currentNode && this.currentNode.classList.remove("is-current");
                    tel.classList.add("is-current");
                    this.currentNode = tel;
                    this.selectData = tel.treeData;
                }
                return this.isExpandItem(tel);
            },
            commonClick(e) {
                let targetEl = e.target || e.srcElement,
                    isTreeItemLabelWrap = targetEl.classList.contains("tree-item-label-wrap"),
                    isTreeItemArrow = targetEl.classList.contains("tree-item-arrow"),
                    isTreeItemLabel = targetEl.classList.contains("tree-item-label"), tel;
                if (isTreeItemArrow || isTreeItemLabel) tel = targetEl.parentNode.parentNode;
                else if (isTreeItemLabelWrap) tel = targetEl.parentNode;
                if (isTreeItemArrow) this.switchClick(tel);
                else if (isTreeItemLabelWrap || isTreeItemLabel) this.clickItem(tel) && this.switchClick(tel);
            },
            switchClick(tel) {
                let childrenWrap = tel.querySelector(".tree-item-child"),
                    isClose = this.checkIsCloseChild(tel);
                childrenWrap && isClose ? this.openChild(tel) : this.closeChild(tel);
                if (!isClose) this.closeAllChild(childrenWrap.children);
                this.$emit('switch', !isClose, tel);
            },
            closeAllChild(children) {
                Array.from(children).forEach(itemNode => {
                    let childrenWrap = itemNode.querySelector(".tree-item-child");
                    this.closeChild(itemNode);
                    this.closeAllChild(childrenWrap.children);
                });
            },
            openAllChild(children) {
                Array.from(children).forEach(itemNode => {
                    let childrenWrap = itemNode.querySelector(".tree-item-child");
                    this.openChild(itemNode);
                    this.openAllChild(childrenWrap.children);
                });
            },
            checkIsCloseChild(childrenWrap) {
                return childrenWrap.classList.contains("is-hide");
            },
            openChild(item) {
                item.classList.remove("is-hide");
                this.isDuplex && this.closeSameLevelItem(item);
            },
            closeChild(item) {
                item.classList.add("is-hide");
            },
            closeSameLevelItem(item) {
                Array.from(item.parentNode.children).forEach(i => i !== item && this.closeChild(i));
            },
            enterSearch() {
                if (!this.treeInfo.firstSearched) this.treeInfo.firstSearched = true;
                if (!this.instantOrEnter && this.data) this.baseData = this.search(this.condition, this.data, this.filterData);
            }
        },
        mounted() {
            this.$el.addEventListener("click", this.commonClick);
            this.baseData && this.baseData.length > 0 && this.$nextTick(this.defaultSelectItem);
            this.treeInfo = {
                defaultSelected: false,
                firstSearched: false
            };
        },
        beforeDestroy() {
            this.$el.removeEventListener("click", this.commonClick);
        },
        watch: {
            loading(d) {
                this.isLoading = d;
            },
            condition(condition) {
                this.conditionMark && clearTimeout(this.conditionMark);
                if (this.instantOrEnter && this.data && this.data.length)
                    this.conditionMark = setTimeout(() => {
                        if (!this.treeInfo.firstSearched) this.treeInfo.firstSearched = true;
                        this.baseData = this.search(condition, this.data, this.filterData);
                    }, this.inputInterval);
            },
            data(data) {
                this.baseData = data;
            },
            baseData(d) {
                // this.isLoading = true;
                d && d.length > 0 && setTimeout(() => {
                    let children = this.$el.querySelector('#base-tree-root').children;
                    this.treeInfo.firstSearched && (this.condition ? this.openAllChild(children) : this.closeAllChild(children));
                    this.defaultSelectItem();
                });
                setTimeout(() => {
                    if (this.isLoading) this.isLoading = false;
                    this.$emit('searched', {data: d, condition: this.condition, selectData: this.selectData});
                });
            },
            defaultSelectData(data) {
                this.selectData = data;
                this.baseData && this.baseData.length > 0 && this.$nextTick(this.defaultSelectItem);
            }
        }
    };
</script>
<style lang="scss">
    @import "../../../scss/animation";

    .base-tree {
        width: 100%;
        height: 100%;
        cursor: default;
        font-size: 12px;
        background-color: #eef1f6;
        user-select: none;
        box-sizing: border-box;
        position: relative;
        transition: width .3s;
        &.not-expand {
            .expand-handle {
                left: 100%;
            }
            width: 0 !important;
            .tree-search, .tree-content {
                display: none;
            }
        }
        .expand-handle {
            width: 23px;
            box-sizing: border-box;
            overflow: hidden;
            position: absolute;
            top: calc(50% - 27.5px);
            left: calc(100% - 23px);
            z-index: 1;
            /*background-color: #cfd9e4;*/
            padding: 18px 1px;
            transition: transform .3s;
            > svg {
                background-color: #cfd9e4;
                transition: transform .3s;
            }
            &:after {
                position: absolute;
                top: 11px;
                transform: rotateZ(63deg);
                z-index: -1;
                content: '';
                display: block;
                width: 22px;
                height: 40px;
                background-color: #cfd9e4;
            }
            &:before {
                position: absolute;
                top: 0;
                transform: rotateZ(117deg);
                z-index: -1;
                content: '';
                display: block;
                width: 22px;
                height: 40px;
                background-color: #cfd9e4;
            }
            &.yes {
                /*> svg {*/
                /*transform: rotateZ(180deg);*/
                /*}*/
                transform: rotateZ(180deg);
            }
            &.no {
                transform: rotateZ(0deg);
                /*> svg {*/
                /*transform: rotateZ(0);*/
                /*}*/
            }
        }
        .is-Loading {
            width: 100%;
            height: calc(100% - 42px);
            background-color: #eef1f6;
            position: absolute;
            bottom: 0;
            left: 0;
            .mounted-before {
                position: absolute;
                top: calc(50% - 15px - 42px);
                left: calc(50% - 15px);
                z-index: 1;
            }
        }
        .tree-content {
            height: calc(100% - 42px);
            overflow-y: auto;
        }
        .tree-search {
            position: relative;
            width: 100%;
            padding: 5px;
            box-sizing: border-box;
            input {
                width: 100%;
                box-sizing: border-box;
                border-radius: 4px;
                border: 1px solid #bfcbd9;
                outline: none;
                height: 32px;
                padding: 3px 22px 3px 10px;
                background-color: #fff;
                font-size: 12px;
                &::placeholder {
                    color: #97a8be;
                }
            }
            .search-handle {
                position: absolute;
                width: 14px;
                right: 13px;
                top: 14px;
                fill: #cfd9e4;
                cursor: pointer;
            }
        }
        .is-empty-data {
            width: 100%;
            height: 100%;
            &:before {
                content: "";
                display: inline-block;
                height: 100%;
                vertical-align: middle;
            }
            p {
                color: #97a8be;
                width: 100%;
                text-align: center;
                display: inline-block;
                vertical-align: middle;
                padding-bottom: 34%;
            }
        }
        .fade-enter-active,
        .fade-leave-active {
            transition: opacity 0.4s ease;
            opacity: 1;
        }
        .fade-enter,
        .fade-leave-to {
            transition: opacity 0.4s ease;
            opacity: 0;
        }
        .base-tree-item {
            $itemHeight: 32px;
            $arrowSize: 10px;
            width: 100%;
            position: relative;
            transition: background-color 200ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
            &:before {
                position: absolute;
                left: 0;
                top: 0;
                content: "";
                display: block;
                height: $itemHeight;
                width: 4px;
                background-color: #eef1f6;
                transition: background-color 200ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
            }
            &.is-current {
                > .tree-item-label-wrap {
                    .tree-item-label {
                        color: #1395f6;
                    }
                }
                &:before {
                    background-color: #1395f6;
                }
            }
            &.is-online {
                > .tree-item-label-wrap {
                    .tree-item-label {
                        &.line,
                        &.vehicle,
                        &.channel {
                            &:before {
                                color: rgb(17, 186, 105);
                            }
                        }
                    }
                }
            }
            .tree-item-label-wrap {
                width: 100%;
                height: $itemHeight;
                display: flex;
                flex-direction: row;
                align-items: center;
                border-bottom: 1px solid #dfe5f0;
                box-sizing: border-box;
                .tree-item-arrow {
                    box-sizing: border-box;
                    width: 12px;
                    display: inline-block;
                    margin: 0 5px;
                    transform: rotateZ(180deg);
                    transition: transform 0.3s;
                }
                .tree-item-label {
                    color: #000;
                    white-space: nowrap;
                    &.line,
                    &.vehicle,
                    &.channel {
                        &:before {
                            font-family: "iconfont" !important;
                            font-size: 16px;
                            font-style: normal;
                            -webkit-font-smoothing: antialiased;
                            color: #9eadc2;
                            margin-right: 5px;
                        }
                    }
                    &.vehicle:before {
                        content: "\E796";
                    }
                    &.channel:before {
                        content: "\E678";
                    }
                }
                &:hover {
                    background-color: #e4e8f1;
                }
            }
            &.is-hide {
                .tree-item-child {
                    display: none;
                }
                > .tree-item-label-wrap {
                    .tree-item-arrow {
                        transform: rotateZ(0);
                    }
                }
            }
            &.is-has-child {
                > .tree-item-label-wrap {
                    .tree-item-arrow {
                        border: 6px solid transparent;
                        border-bottom-width: 0;
                        border-top-color: #97a8be;
                        border-top-width: 7px;
                    }
                }
            }
        }
    }
</style>




// WEBPACK FOOTER //
// main.vue?4ede1213